import {Client} from '@bugsnag/js'
import React from 'react'

export interface IBugsnagNextAppContext {
    ctx: {
        bugsnag: Client
    };
}

const BugsnagContext = React.createContext<Client | null>(null)

export const BugsnagProvider = BugsnagContext.Provider
export const BugsnagConsumer = BugsnagContext.Consumer